import React, { useState, useEffect, useRef } from 'react';
import styles from '../../styles/EraTable.module.css';

/**
 * 情報アイコンとツールチップコンポーネント
 */
const InfoTooltip = () => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const tooltipRef = useRef(null);
  const iconRef = useRef(null);

  const toggleTooltip = (e) => {
    e.preventDefault();
    setTooltipVisible(!tooltipVisible);
  };

  // ツールチップ以外をクリックした時に閉じる
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        tooltipVisible &&
        tooltipRef.current &&
        iconRef.current &&
        !tooltipRef.current.contains(e.target) &&
        !iconRef.current.contains(e.target)
      ) {
        setTooltipVisible(false);
      }
    };

    // タッチデバイス用
    document.addEventListener('touchstart', handleOutsideClick);
    // マウス用
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('touchstart', handleOutsideClick);
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [tooltipVisible]);

  return (
    <span 
      className={styles.infoIcon} 
      ref={iconRef}
      onClick={toggleTooltip}
      onTouchStart={toggleTooltip}
    >
      i
      <div 
        className={`${styles.tooltipContent} ${tooltipVisible ? styles.tooltipVisible : ''}`}
        ref={tooltipRef}
      >
        <h5>計算式</h5>
        <div className={styles.tooltipItem}>令和 = 西暦 - 2018年</div>
        <div className={styles.tooltipItem}>平成 = 西暦 - 1988年</div>
        <div className={styles.tooltipItem}>昭和 = 西暦 - 1925年</div>
        <div className={styles.tooltipItem}>大正 = 西暦 - 1911年</div>
        <div className={styles.tooltipItem}>明治 = 西暦 - 1867年</div>
      </div>
    </span>
  );
};

export default InfoTooltip; 